// App.tsx
import { useEffect, useState} from 'react';
import SignedOutView from './components/SignedOutView';
import UserMenu from './components/UserMenu';
import ViewTaskPage from './pages/ViewTaskPage.tsx';
import LandingPage from './pages/LandingPage.tsx';
import EnvironmentsPage from './pages/EnvironmentsPage.tsx';
import NewEnvironmentPage from './pages/NewEnvironmentPage.tsx';
import ViewEnvironmentPage from './pages/ViewEnvironmentPage.tsx';
import EditEnvironmentPage from './pages/EditEnvironmentPage.tsx';
import ConfigureBranchesPage from './pages/ConfigureBranchesPage.tsx';
import ConfigureGithubPage from './pages/ConfigureGithubPage.tsx';
import WorkstreamTaskPage from './pages/WorkstreamTaskPage.tsx';
import WorkstreamViewPage from './pages/WorkstreamViewPage.tsx';
import WorkstreamsPage from './pages/WorkstreamsPage.tsx';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TaskProvider } from './context/TaskContext';
import type { GoogleUser } from './types/auth';
import CreateTaskPage from './pages/CreateTaskPage.tsx';
import Cookies from 'js-cookie';

declare global {
  interface Window {
    google?: any;
  }
}

export default function App() {
  const [user, setUser] = useState<GoogleUser | null>(null);
  const [googleInitialized, setGoogleInitialized] = useState(false);

  // Initialize Google auth once on component mount
  useEffect(() => {
    const userStr =  Cookies.get('User');

    if (userStr) {
      try {
        setUser(JSON.parse(userStr!) as GoogleUser);
      } catch (e) {
        console.error('Failed to parse stored user data');

        localStorage.removeItem('user');
      }
    }

    // Initialize Google auth when the library loads
    const initializeGoogleAuth = () => {
      if (window.google?.accounts) {
        window.google.accounts.id.initialize({
          client_id: '734155928094-d3oge1jmeo8r2bjoi897vqgp4nu4964l.apps.googleusercontent.com',
          ux_mode: 'redirect',
          login_uri: `${window.location.origin}/login`
        });
        setGoogleInitialized(true);
      }
    };

    if (window.google?.accounts) {
      initializeGoogleAuth();
    } else {
      // Wait for the Google library to load
      const checkGoogleLibrary = setInterval(() => {
        if (window.google?.accounts) {
          initializeGoogleAuth();
          clearInterval(checkGoogleLibrary);
        }
      }, 100);

      // Don't wait forever
      setTimeout(() => clearInterval(checkGoogleLibrary), 10000);
    }
  }, []);

  if (!user) {
    return <SignedOutView googleInitialized={googleInitialized} />;
  }

  return (
    <BrowserRouter>
      <TaskProvider>
        <UserMenu user={user} />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/tasks/new" element={<CreateTaskPage />} />
          <Route path="/tasks/new/branches" element={<ConfigureBranchesPage />} />
          <Route path="/tasks/:taskID" element={<ViewTaskPage />} />
          <Route path="/workstreams/tasks/:workstreamID/:taskID/turns/:turnID" element={<ViewTaskPage />} />
          <Route path="/workstreams/tasks/:workstreamID/:taskID" element={<WorkstreamTaskPage />} />
          <Route path="/workstreams/tasks/:shortNameAndTaskNum" element={<WorkstreamTaskPage />} />
          <Route path="/workstreams" element={<WorkstreamsPage />} />
          <Route path="/workstreams/:workstreamID" element={<WorkstreamViewPage />} />
          <Route path="/environments" element={<EnvironmentsPage />} />
          <Route path="/environments/new" element={<NewEnvironmentPage />} />
          <Route path="/environments/:environmentID" element={<ViewEnvironmentPage />} />
          <Route path="/environments/:environmentID/edit" element={<EditEnvironmentPage />} />
          <Route path="/settings/github" element={<ConfigureGithubPage />} />
        </Routes>
      </TaskProvider>
    </BrowserRouter>
  );
}
